import EditCalendar from "@mui/icons-material/EditCalendar";
import {
  FormControlLabel,
  IconButton,
  Skeleton,
  Stack,
  Switch,
  Tooltip,
  Typography,
} from "@mui/material";

const TOGGLE_LABEL = "Create Permit Renewal Task";

type CreatePermitRenewalTaskToggleProps = {
  checked: boolean;
  disabled: boolean;
  loading?: boolean;
  tooltip: string | null;
  onChange: (checked: boolean) => void;
  onJumpToDueDate?: () => void;
};

function ToggleLabel({ tooltip }: { tooltip: string | null }) {
  const label = (
    <Typography component="span" variant="body2">
      {TOGGLE_LABEL}
    </Typography>
  );

  if (tooltip == null) {
    return label;
  }

  return (
    <Tooltip title={tooltip} arrow>
      <span>{label}</span>
    </Tooltip>
  );
}

export function CreatePermitRenewalTaskToggle({
  checked,
  disabled,
  loading = false,
  tooltip,
  onChange,
  onJumpToDueDate,
}: CreatePermitRenewalTaskToggleProps) {
  if (loading) {
    return <Skeleton variant="rounded" width={300} height={32} />;
  }

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <FormControlLabel
        control={
          <Switch
            size="small"
            checked={checked}
            disabled={disabled}
            onChange={(_, nextChecked) => onChange(nextChecked)}
          />
        }
        label={<ToggleLabel tooltip={tooltip} />}
        sx={{ mr: 0, ml: 0 }}
      />
      {onJumpToDueDate ? (
        <Tooltip title="Jump to due date" arrow>
          <IconButton
            size="small"
            onClick={onJumpToDueDate}
            aria-label="Jump to due date"
            sx={{ color: "text.secondary", ml: 0.25 }}
          >
            <EditCalendar sx={{ fontSize: 18 }} />
          </IconButton>
        </Tooltip>
      ) : null}
    </Stack>
  );
}
